import {Dispatchable} from "../../../stem-core/base/Dispatcher";
import {iFrameConnection} from "../../services/IFrameConnection.js";
import {IFrameMessages} from "../../../blink-sdk/messaging/IFrameMessages.js";
import {AnalyticsEventType, dispatchAnalyticsEvent} from "../../../blink-sdk/utils/AnalyticsClient.js";
import {iFrameState} from "../../services/IFrameState.js";
import {FlowPlan} from "./Flow.js";
import {type PanelType} from "../../../blink-sdk/Constants";
import type {BaseFlowStep} from "./steps/BaseFlowStep";


export function sendFlowCheckpoint(flowType: string, flowCheckpoint: string, payload: Record<string, any>, extra?: Record<string, any>) {
    dispatchAnalyticsEvent(AnalyticsEventType.FLOW_CHECKPOINT, {flowType, flowCheckpoint, ...payload});
    iFrameConnection.sendToSDK(IFrameMessages.FLOW_CHECKPOINT, {
        event: {
            flowType,
            flowCheckpoint,
            ...payload,
        },
        extra,
    });
}


// Every concrete handler implements these; merged in rather than declared as fields so a
// subclass can define them as ordinary methods.
export interface BaseFlowHandler {
    getFlowPlan(): any[];
    finalize(...args: any[]): any;
}

export class BaseFlowHandler extends Dispatchable {
    // Snapshotted off iFrameState by saveInitialOptions(); subclasses set panelType
    declare skipCTA?: boolean;
    declare editRecurring?: boolean;
    declare panelType?: PanelType;
    // Needed to avoid a reset on an active flow that's already doing this
    sameAsNewOptions(panelType: string) {
        const {skipCTA, editRecurring} = iFrameState;

        // TODO @flow If we already skipped the CTA, no point in reverting back to a previous state
        const ignoreSkipCTA = this.skipCTA === skipCTA || this.skipCTA;

        return this.panelType === panelType && this.editRecurring === editRecurring && ignoreSkipCTA;
    }

    saveInitialOptions() {
        this.skipCTA = iFrameState.skipCTA;
        this.editRecurring = iFrameState.editRecurring;
    }

    makeFlowPlan(steps?: BaseFlowStep[]) {
        if (!steps) {
            steps = this.getFlowPlan();
        }
        return new FlowPlan(steps, () => this.finalize());
    }
}

